module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/half1.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/list"
    }
  }, [_c('i', [_vm._v("List of Illustrations ix")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/ack"
    }
  }, [_c('i', [_vm._v("Acknowledgments xi")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/abb"
    }
  }, [_c('i', [_vm._v("Abbreviations xv")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/map"
    }
  }, [_c('i', [_vm._v("Maps xvi")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/int"
    }
  }, [_vm._v("Introduction "), _c('i', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_c('i', [_vm._v("Chapter 1")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Absence "), _c('i', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 2")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Empire "), _c('i', [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 3")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Hellenism "), _c('i', [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 4")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" The Realms of Gold "), _c('i', [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 5")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" The Very Model of Orthodoxy? "), _c('i', [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue "), _c('i', [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes 117")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/further",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Further Reading 149")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Author’s Note 155")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index 157")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 75
// module chunks = 0